import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricBeatRate extends MetricBase {
    constructor() {
        super({
            field: "metric_beat_rate",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.beatRate.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.beatRate.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.beatRate.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBeatRate;
